/**
 * @generated SignedSource<<e34c99b6b25621bb314a5b83ca130525>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type taskModalV3_Query$variables = {
  id?: string | null;
  withCommentReactions: boolean;
};
export type taskModalV3_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"taskModalV3_viewer">;
  } | null;
};
export type taskModalV3_Query = {
  variables: taskModalV3_Query$variables;
  response: taskModalV3_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withCommentReactions"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "task_modal_v3"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"task_modal_v3\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "harvestUser",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v3/*: any*/)
],
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v15 = [
  (v3/*: any*/)
],
v16 = [
  (v3/*: any*/),
  (v13/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v30 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v40 = [
  (v3/*: any*/),
  (v13/*: any*/),
  (v20/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "StatusColumnV2",
    "kind": "LinkedField",
    "name": "statusColumnV2",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v39/*: any*/)
    ],
    "storageKey": null
  }
],
v41 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DependencyTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DependencyType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "taskDependsOnThis",
            "plural": false,
            "selections": (v40/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "thisDependsOnTask",
            "plural": false,
            "selections": (v40/*: any*/),
            "storageKey": null
          },
          (v36/*: any*/)
        ],
        "storageKey": null
      },
      (v37/*: any*/)
    ],
    "storageKey": null
  },
  (v38/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v43 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5000
  }
],
v44 = [
  (v3/*: any*/),
  (v18/*: any*/)
],
v45 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FileTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mimeType",
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "yearCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hourCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minuteCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": (v44/*: any*/),
            "storageKey": null
          },
          (v36/*: any*/)
        ],
        "storageKey": null
      },
      (v37/*: any*/)
    ],
    "storageKey": null
  },
  (v38/*: any*/)
],
v46 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v47 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "taskModalV3_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              }
            ],
            "kind": "FragmentSpread",
            "name": "taskModalV3_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "taskModalV3_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backendId",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timerStartDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timerEndDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "useDetailedSubtasks",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "githubConnected",
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraServerEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraCloud",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraServer",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pipedriveCompanyDomain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "githubEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gdriveEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "characterLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(first:10000)"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "LabelTypeConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "allowOnTasks",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "allowOnProjects",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "allowOnPeople",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "labels(first:10000)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "timerTask",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "client",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "companyTaskId",
                "variableName": "id"
              }
            ],
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userCanDeleteTask",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userCantDeleteTaskReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullAccessToProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "approved",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskReadOnly",
                "kind": "LinkedField",
                "name": "readOnly",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isReadOnly",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "coverFile",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentTaskId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentRun",
                "kind": "LinkedField",
                "name": "novaThread",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "runId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "threadId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "agentId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "versionNumber",
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "outcome",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userMessageText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NovaRunAuthor",
                    "kind": "LinkedField",
                    "name": "actingPerson",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ranAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "failureState",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NovaGroundingAccount",
                    "kind": "LinkedField",
                    "name": "grounding",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NovaGroundingResolvedEntry",
                        "kind": "LinkedField",
                        "name": "resolved",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scope",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NovaGroundingReferenceEntry",
                        "kind": "LinkedField",
                        "name": "skipped",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "parentTask",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v20/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "parentTask",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v20/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasChildren",
                "storageKey": null
              },
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bug",
                "storageKey": null
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "highPriority",
                "storageKey": null
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabIid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pipedriveId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUnit4Task",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimateForecast",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeLeft",
                "storageKey": null
              },
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deadlineFrom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerIid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasLockedTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoicedTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "favoured",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskProgress",
                "kind": "LinkedField",
                "name": "progressDetails",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "progress",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "followers",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskLabel",
                "kind": "LinkedField",
                "name": "taskLabels",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "label",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "concreteType": "SubTaskTypeConnection",
                "kind": "LinkedField",
                "name": "subTasks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SubTaskTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SubTask",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "done",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sortOrder",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v25/*: any*/),
                          (v24/*: any*/),
                          (v23/*: any*/),
                          (v22/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endFrom",
                            "storageKey": null
                          },
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v35/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/)
                ],
                "storageKey": "subTasks(first:1000)"
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Task_subTasks",
                "kind": "LinkedHandle",
                "name": "subTasks"
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "concreteType": "DependencyTypeConnection",
                "kind": "LinkedField",
                "name": "thisTaskDependsOn",
                "plural": false,
                "selections": (v41/*: any*/),
                "storageKey": "thisTaskDependsOn(first:1000)"
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Task_thisTaskDependsOn",
                "kind": "LinkedHandle",
                "name": "thisTaskDependsOn"
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "concreteType": "DependencyTypeConnection",
                "kind": "LinkedField",
                "name": "dependsOnThisTask",
                "plural": false,
                "selections": (v41/*: any*/),
                "storageKey": "dependsOnThisTask(first:1000)"
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Task_dependsOnThisTask",
                "kind": "LinkedHandle",
                "name": "dependsOnThisTask"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RepeatingTask",
                "kind": "LinkedField",
                "name": "repeatingTask",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "repeatType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "monday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tuesday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wednesday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thursday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "friday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "saturday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sunday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "monthlyDay",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusColumnV2",
                "kind": "LinkedField",
                "name": "statusColumnV2",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v39/*: any*/),
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseType",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Sprint",
                "kind": "LinkedField",
                "name": "sprint",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "assignedPersons",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v34/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v43/*: any*/),
                "concreteType": "TimeRegTypeConnection",
                "kind": "LinkedField",
                "name": "timeRegistrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoiced",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "xeroInvoiceId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minutesRegistered",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lockedInPeriod",
                            "storageKey": null
                          },
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/)
                ],
                "storageKey": "timeRegistrations(first:5000)"
              },
              {
                "alias": null,
                "args": (v43/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Task_timeRegistrations",
                "kind": "LinkedHandle",
                "name": "timeRegistrations"
              },
              (v34/*: any*/),
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "GoogleDriveFileTypeConnection",
                "kind": "LinkedField",
                "name": "googleDriveFiles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GoogleDriveFileTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GoogleDriveFile",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "link",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumb",
                            "storageKey": null
                          },
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/)
                ],
                "storageKey": "googleDriveFiles(first:10000)"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Task_googleDriveFiles",
                "kind": "LinkedHandle",
                "name": "googleDriveFiles"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "FileTypeConnection",
                "kind": "LinkedField",
                "name": "files",
                "plural": false,
                "selections": (v45/*: any*/),
                "storageKey": "files(first:10000)"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Task_files",
                "kind": "LinkedHandle",
                "name": "files"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "FileTypeConnection",
                "kind": "LinkedField",
                "name": "referencedFiles",
                "plural": false,
                "selections": (v45/*: any*/),
                "storageKey": "referencedFiles(first:10000)"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Task_referencedFiles",
                "kind": "LinkedHandle",
                "name": "referencedFiles"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commentCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v46/*: any*/),
                "concreteType": "CommentTypeConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "comment",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "year",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "month",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "day",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hours",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minutes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "seconds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v18/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "withCommentReactions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentReactionType",
                                "kind": "LinkedField",
                                "name": "reactions",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "emoji",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "count",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "viewerHasReacted",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "kind": "LinkedField",
                                    "name": "persons",
                                    "plural": true,
                                    "selections": (v44/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          },
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/)
                ],
                "storageKey": "comments(first:100000)"
              },
              {
                "alias": null,
                "args": (v46/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Task_comments",
                "kind": "LinkedHandle",
                "name": "comments"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v47/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latestUiUpdateAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "latestUiUpdateBy",
                "plural": false,
                "selections": (v47/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v18/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useTaskOwner",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useTaskFollowers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useTaskHierarchy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectStartYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectStartMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectStartDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectEndYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectEndMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectEndDay",
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isJiraProject",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jiraSubtaskType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraCloudProjectType",
                    "kind": "LinkedField",
                    "name": "jiraCloudProject",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jiraCloudEpicIds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraServerProjectType",
                    "kind": "LinkedField",
                    "name": "jiraServerProject",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gitlabProjectName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gitlabServerProjectName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectGroupId",
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taskLevels",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyProjectId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customProjectId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isProgramRevenueLocked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "programBudgetType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProgramType",
                    "kind": "LinkedField",
                    "name": "program",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "prefix",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "budgetType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectServiceProgramMemberTypeConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectServiceProgramMemberTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectServiceProgramMemberType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "role",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HarvestProjectType",
                    "kind": "LinkedField",
                    "name": "harvestProject",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "manualProgressOnProjectEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "manualProgressOnPhasesEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "manualProgressOnTasksEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vstsProject",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vstsAccount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vstsTwoWaySync",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sprintTimeBox",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimationUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remainingAutoCalculated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateCard",
                    "kind": "LinkedField",
                    "name": "rateCard",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "disabledRoles",
                        "plural": true,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "ProjectPersonTypeConnection",
                    "kind": "LinkedField",
                    "name": "projectPersons",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPersonTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectPerson",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v18/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "permissions",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectType",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": (v15/*: any*/),
                                "storageKey": null
                              },
                              (v34/*: any*/),
                              (v36/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v37/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v38/*: any*/)
                    ],
                    "storageKey": "projectPersons(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "Project_projectPersons",
                    "kind": "LinkedHandle",
                    "name": "projectPersons"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Client",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "logoId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "logoDefaultId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "PhaseTypeConnection",
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v28/*: any*/),
                              (v27/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "phases(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000000
                      }
                    ],
                    "concreteType": "StatusColumnV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "statusColumnsV2",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v39/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "order",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "jiraStatusId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "adoState",
                                "storageKey": null
                              },
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StatusColumnUserActions",
                                "kind": "LinkedField",
                                "name": "userActions",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "canDelete",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "canDeleteWithTasks",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "canCreateTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "canRename",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "statusColumnsV2(first:1000000)"
                  },
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "SprintTypeConnection",
                    "kind": "LinkedField",
                    "name": "sprints",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SprintTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v33/*: any*/),
                              (v32/*: any*/),
                              (v31/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "sprints(first:10000)"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80d6f3f85afcc090f8206cd96facecc1",
    "id": null,
    "metadata": {},
    "name": "taskModalV3_Query",
    "operationKind": "query",
    "text": "query taskModalV3_Query(\n  $id: String\n  $withCommentReactions: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"task_modal_v3\")\n    ...taskModalV3_viewer_1Bmzm5\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment LabelDropdownJS_labels on Label {\n  color\n  name\n  id\n  category {\n    id\n    name\n  }\n}\n\nfragment RoleDropdown_roles on RoleTypeEdge {\n  node {\n    name\n    id\n  }\n}\n\nfragment optionsSection_company on Company {\n  gitlabServerUrl\n  jiraCloudEnabled\n  jiraServerEnabled\n  integrations {\n    jiraCloud {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    jiraServer {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment taskModalV3_viewer_1Bmzm5 on Viewer {\n  id\n  backendId\n  actualPersonId\n  email\n  firstName\n  lastName\n  harvestUser\n  timerStartDate\n  timerEndDate\n  useDetailedSubtasks\n  githubConnected\n  profilePictureId\n  profilePictureDefaultId\n  availableFeatureFlags {\n    key\n    id\n  }\n  company {\n    ...optionsSection_company\n    id\n    modules {\n      moduleType\n      id\n    }\n    pipedriveCompanyDomain\n    githubEnabled\n    gdriveEnabled\n    gitlabServerUrl\n    characterLimit\n    roles(first: 10000) {\n      edges {\n        ...RoleDropdown_roles\n        node {\n          id\n          name\n        }\n      }\n    }\n    labels(first: 10000) {\n      edges {\n        node {\n          id\n          name\n          category {\n            allowOnTasks\n            allowOnProjects\n            allowOnPeople\n            id\n          }\n          ...LabelDropdownJS_labels\n        }\n      }\n    }\n  }\n  timerTask {\n    id\n  }\n  client {\n    id\n    name\n  }\n  task(companyTaskId: $id) {\n    id\n    userCanDeleteTask\n    userCantDeleteTaskReason\n    fullAccessToProject\n    approved\n    name\n    readOnly {\n      isReadOnly\n      id\n    }\n    coverFile {\n      id\n    }\n    parentTaskId\n    novaThread {\n      id\n      runId\n      threadId\n      agentId\n      versionNumber\n      status\n      outcome\n      answer\n      userMessageText\n      actingPerson {\n        fullName\n        profilePictureId\n      }\n      ranAt\n      failureState\n      grounding {\n        resolved {\n          token\n          scope\n        }\n        skipped {\n          token\n        }\n      }\n    }\n    parentTask {\n      id\n      companyTaskId\n      name\n      parentTask {\n        id\n        companyTaskId\n        name\n      }\n    }\n    hasChildren\n    companyTaskId\n    blocked\n    bug\n    billable\n    highPriority\n    startYear\n    startMonth\n    startDay\n    description\n    jiraId\n    jiraKey\n    gitlabIid\n    vstsId\n    pipedriveId\n    isUnit4Task\n    estimateForecast\n    timeLeft\n    deadlineDay\n    deadlineMonth\n    deadlineYear\n    startFrom\n    deadlineFrom\n    gitlabServerIid\n    hasLockedTime\n    hasInvoicedTime\n    favoured\n    sageIntacctId\n    progressDetails {\n      progress\n      id\n    }\n    followers {\n      id\n      firstName\n      lastName\n      profilePictureId\n      profilePictureDefaultId\n    }\n    taskLabels {\n      label {\n        id\n        name\n        color\n      }\n      id\n    }\n    subTasks(first: 1000) {\n      edges {\n        node {\n          id\n          estimate\n          done\n          sortOrder\n          name\n          description\n          startDay\n          startMonth\n          startYear\n          endDay\n          endMonth\n          endYear\n          startFrom\n          endFrom\n          role {\n            id\n            name\n          }\n          person {\n            id\n            firstName\n            lastName\n            active\n            profilePictureId\n            profilePictureDefaultId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    thisTaskDependsOn(first: 1000) {\n      edges {\n        node {\n          id\n          type\n          completed\n          taskDependsOnThis {\n            id\n            name\n            companyTaskId\n            startYear\n            startMonth\n            startDay\n            deadlineDay\n            deadlineMonth\n            deadlineYear\n            statusColumnV2 {\n              id\n              category\n            }\n          }\n          thisDependsOnTask {\n            id\n            name\n            companyTaskId\n            startYear\n            startMonth\n            startDay\n            deadlineDay\n            deadlineMonth\n            deadlineYear\n            statusColumnV2 {\n              id\n              category\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    dependsOnThisTask(first: 1000) {\n      edges {\n        node {\n          id\n          type\n          completed\n          taskDependsOnThis {\n            id\n            name\n            companyTaskId\n            startYear\n            startMonth\n            startDay\n            deadlineDay\n            deadlineMonth\n            deadlineYear\n            statusColumnV2 {\n              id\n              category\n            }\n          }\n          thisDependsOnTask {\n            id\n            name\n            companyTaskId\n            startYear\n            startMonth\n            startDay\n            deadlineDay\n            deadlineMonth\n            deadlineYear\n            statusColumnV2 {\n              id\n              category\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    repeatingTask {\n      id\n      repeatType\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n      monthlyDay\n    }\n    statusColumnV2 {\n      id\n      name\n      category\n      projectGroupStatusColumnId\n    }\n    phase {\n      id\n      name\n      startYear\n      startMonth\n      startDay\n      deadlineDay\n      deadlineMonth\n      deadlineYear\n    }\n    sprint {\n      id\n      name\n      startYear\n      startMonth\n      startDay\n      endDay\n      endMonth\n      endYear\n    }\n    assignedPersons {\n      id\n      firstName\n      lastName\n      role {\n        id\n        name\n      }\n      profilePictureId\n      profilePictureDefaultId\n      email\n    }\n    timeRegistrations(first: 5000) {\n      edges {\n        node {\n          id\n          invoiced\n          xeroInvoiceId\n          minutesRegistered\n          lockedInPeriod\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    role {\n      id\n      name\n    }\n    googleDriveFiles(first: 10000) {\n      edges {\n        node {\n          id\n          name\n          link\n          thumb\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    files(first: 10000) {\n      edges {\n        node {\n          id\n          name\n          mimeType\n          key\n          size\n          yearCreated\n          monthCreated\n          dayCreated\n          hourCreated\n          minuteCreated\n          secondCreated\n          person {\n            id\n            fullName\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    referencedFiles(first: 10000) {\n      edges {\n        node {\n          id\n          name\n          mimeType\n          key\n          size\n          yearCreated\n          monthCreated\n          dayCreated\n          hourCreated\n          minuteCreated\n          secondCreated\n          person {\n            id\n            fullName\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    commentCount\n    comments(first: 100000) {\n      edges {\n        node {\n          id\n          comment\n          year\n          month\n          day\n          hours\n          minutes\n          seconds\n          person {\n            id\n            firstName\n            lastName\n            fullName\n            profilePictureId\n            profilePictureDefaultId\n          }\n          reactions @include(if: $withCommentReactions) {\n            emoji\n            count\n            viewerHasReacted\n            persons {\n              id\n              fullName\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    createdAt\n    createdBy {\n      id\n      firstName\n      lastName\n    }\n    latestUiUpdateAt\n    latestUiUpdateBy {\n      id\n      firstName\n      lastName\n    }\n    owner {\n      id\n      firstName\n      lastName\n      fullName\n      profilePictureId\n      profilePictureDefaultId\n      role {\n        id\n        name\n      }\n    }\n    project {\n      id\n      name\n      useTaskOwner\n      useTaskFollowers\n      useTaskHierarchy\n      projectStartYear\n      projectStartMonth\n      projectStartDay\n      projectEndYear\n      projectEndMonth\n      projectEndDay\n      status\n      projectColor\n      isJiraProject\n      jiraSubtaskType\n      jiraCloudProject {\n        id\n      }\n      jiraCloudEpicIds\n      jiraServerProject {\n        id\n      }\n      gitlabProjectName\n      gitlabServerProjectName\n      projectGroupId\n      billable\n      taskLevels\n      companyProjectId\n      customProjectId\n      ...DeprecatedProjectIndicatorJS_project\n      isProgramRevenueLocked\n      programBudgetType\n      program {\n        name\n        prefix\n        budgetType\n        members {\n          edges {\n            node {\n              role\n              person {\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      harvestProject {\n        id\n      }\n      manualProgressOnProjectEnabled\n      manualProgressOnPhasesEnabled\n      manualProgressOnTasksEnabled\n      vstsProject\n      vstsAccount\n      vstsTwoWaySync\n      sprintTimeBox\n      estimationUnit\n      remainingAutoCalculated\n      rateCard {\n        id\n        disabledRoles {\n          id\n        }\n      }\n      projectPersons(first: 10000) {\n        edges {\n          node {\n            id\n            person {\n              id\n              firstName\n              lastName\n              fullName\n              profilePictureId\n              profilePictureDefaultId\n              active\n              permissions\n              harvestUser\n            }\n            project {\n              id\n            }\n            role {\n              id\n              name\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      client {\n        id\n        name\n        logoId\n        logoDefaultId\n      }\n      phases(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            deadlineYear\n            deadlineMonth\n            deadlineDay\n          }\n        }\n      }\n      statusColumnsV2(first: 1000000) {\n        edges {\n          node {\n            id\n            name\n            category\n            order\n            jiraStatusId\n            adoState\n            projectGroupStatusColumnId\n            userActions {\n              canDelete\n              canDeleteWithTasks\n              canCreateTask\n              canRename\n              id\n            }\n          }\n        }\n      }\n      sprints(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            endYear\n            endMonth\n            endDay\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aad6a513c5af7199d52b775c38eb2f68";

export default node;
